export default __webpack_public_path__ + "static/media/manage_hugeicons_car.e0954d71.svg";